import { render, staticRenderFns } from "./TransferRequestDetailsView.vue?vue&type=template&id=4527af51&scoped=true&"
import script from "./TransferRequestDetailsView.vue?vue&type=script&lang=js&"
export * from "./TransferRequestDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4527af51",
  null
  
)

export default component.exports